import AntPagination, { PaginationConfig } from "antd/lib/pagination";
import clsx from "clsx";

export type PaginationProps = PaginationConfig;

export const Pagination = ({ className, ...props }: PaginationProps) => {
    return <AntPagination className={clsx("flex", className)} {...props} />;
};
